import React, {useEffect} from "react"
import Title from "../components/Title";
import Box from "../components/Box";
import Screen from "../components/Screen";
import {toI18N} from "../utils/I18n";
import Carousel from '@brainhubeu/react-carousel';
import '@brainhubeu/react-carousel/lib/style.css';
import Button from "../components/Button";
import Icon from "../components/Icon";
import icons from "../css/Icon.module.css";
import styles from "../css/App.module.css";
import {isMobile} from "react-device-detect";
import {usePrevious} from "../utils/HooksHelper";
import * as Analytics from "../utils/Analytics";

interface Props {
    loggedIn: boolean,
    isInMiddleOfLoggingIn: boolean,
    onNext: () => void,
    isActive: boolean,
}

const examples = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14].map(n => toI18N(`${n}-example`));

const WelcomeScreen = (props: Props) => {

    // @ts-ignore
    const {reactAppVersion} = window;

    const exampleWidth = (()=> {
        // So it will look good on device browser)
        if (window.innerHeight > 810) {
            return 250;
        } else if (window.innerHeight > 610) {
            return 200;
        }

        return 150;

    })();

    const {
        loggedIn,
        isInMiddleOfLoggingIn,
        isActive,
    } = props;

    const prevIsActive = usePrevious(isActive);
    const prevIsLoggedIn = usePrevious(loggedIn);
    useEffect(() => {
        if (!prevIsActive && isActive) {
            Analytics.logEvent(Analytics.events.land_on_welcome_page);
        }
        if (!prevIsLoggedIn && loggedIn) {
            props.onNext()
        }
    }, [isActive, loggedIn, prevIsActive, prevIsLoggedIn, props]);

    return (
        <Screen
            // @ts-ignore
            title={reactAppVersion}
            subtitle={''}
            hideBack
            hideNext
        >

            <Box sideMargin bottomMargin={25} topMargin={isMobile ? 25 : 70}>
                <Title lg title={toI18N("general_app_name")} subtitle={toI18N("welcome_subtitle")}/>
            </Box>

            <div className={styles.examplesCarousel} style={{minHeight: exampleWidth * 16 / 9}}>
                <Carousel
                    autoPlay={3000}
                    offset={20}
                    itemWidth={exampleWidth}
                    animationSpeed={250}
                    centered
                    infinite
                >

                    {
                        examples.map((example: string, index: number) => {
                            return <img key={`${index}_example`} style={{width: exampleWidth}} src={examples[index]}
                                        alt={`${index}-example`}/>;
                        })
                    }

                </Carousel>
            </div>

            <Box center topMargin={25} bottomMargin={25}>
                <Button primary onClick={props.onNext} isLoading={isInMiddleOfLoggingIn || loggedIn} >
                    <Icon white name={icons.iconArrowRight}/>
                </Button>
            </Box>

        </Screen>
    );
};

export default WelcomeScreen;
